import { render, staticRenderFns } from "./ObraEditar.vue?vue&type=template&id=01f793f9&scoped=true"
import script from "./ObraEditar.vue?vue&type=script&lang=js"
export * from "./ObraEditar.vue?vue&type=script&lang=js"
import style0 from "./ObraEditar.vue?vue&type=style&index=0&id=01f793f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f793f9",
  null
  
)

export default component.exports